export type LoginScreenState =
	| { type: "redirect"; href: "/home" | `/redeem?redeemCode=${string}` }
	| { type: "awaiting-metadata" }
	| { type: "form" };

type GetLoginScreenStateOptions = {
	isSignedIn: boolean;
	userLogicalId: string | undefined;
	redeemCode: string | undefined;
	hasTimedOut: boolean;
};

export const getLoginScreenState = ({
	isSignedIn,
	userLogicalId,
	redeemCode,
	hasTimedOut,
}: GetLoginScreenStateOptions): LoginScreenState => {
	if (!isSignedIn) {
		return { type: "form" };
	}

	if (!userLogicalId) {
		return hasTimedOut ? { type: "form" } : { type: "awaiting-metadata" };
	}

	return {
		type: "redirect",
		href: redeemCode ? `/redeem?redeemCode=${redeemCode}` : "/home",
	};
};
